import "./DataPlaceholder.css";

const DataPlaceholder = ({ id, title, comment, selected }) => {
  return (
    <div className={`data-placeholder ${selected ? "selected" : ""}`} key={id}>
      <div className="data-placeholder-title App-text-small">{title}</div>
      {comment && (
        <div className="data-placeholder-comment App-text-small">
          ({comment})
        </div>
      )}
    </div>
  );
};
export default DataPlaceholder;
